// extracted by mini-css-extract-plugin
export default {"col_box":"index_col_box_6q5tr","col_navlist":"index_col_navlist_0xpJU","pa":"index_pa_RQv5J"};